import Nurturingphoto from "../assets/Nurturing.jpg";
import Honoring from "../assets/Honoring.jpg";
import Community from "../assets/Community.jpg";
import Empowerment from "../assets/Empowerment.jpg";
import Group from "../assets/Group.jpg";

function Commitments() {
  return (
    <section id="commitments" className="py-20 px-4 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-5xl md:text-6xl font-black mb-4">
            My Social Commitments
          </h2>
          <p className="text-lg text-gray-600">
            We need to empower and support society!
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {/* Card 1 */}
          <div className="bg-white  shadow-lg p-6 flex flex-col gap-4 hover:shadow-2xl transition-all">
            <img
              src={Nurturingphoto}
              alt="Nurturing the Next Generation"
              className=" w-full h-80 md:h-96 object-cover mb-4"
            />
            <h3 className="text-xl font-bold mb-2 flex items-center justify-between">
              Nurturing the Next Generation
            </h3>
            <p className="text-gray-600">
              Spending quality time with children is my greatest joy. There’s
              nothing like sharing pure-hearted moments with these little
              angels—it reminds me why education matters most.
            </p>
          </div>
          {/* Card 2 */}
          <div className="bg-white  shadow-lg p-6 flex flex-col gap-4 hover:shadow-2xl transition-all">
            <img
              src={Honoring}
              alt="Honoring Our Elders"
              className=" w-full h-80 md:h-96 object-cover mb-4"
            />
            <h3 className="text-xl font-bold mb-2 flex items-center justify-between">
              Honoring Our Elders
            </h3>
            <p className="text-gray-600">
              Respecting and learning from elders is a cornerstone of my values.
              Their wisdom and contributions deserve to be celebrated and
              remembered in every step we take.
            </p>
          </div>
          {/* Card 3 */}
          <div className="bg-white shadow-lg p-6 flex flex-col gap-4 hover:shadow-2xl transition-all">
            <img
              src={Community}
              alt="Standing with My Community"
              className=" w-full h-80 md:h-96 object-cover mb-4"
            />
            <h3 className="text-xl font-bold mb-2 flex items-center justify-between">
              Standing with My Community
            </h3>
            <p className="text-gray-600">
              In times of need, I’m there for my country and its
              people—volunteering, advocating, and empowering collective action.
              We need to support and uplift society, one shared effort at a
              time!
            </p>
          </div>
          {/* Card 4 */}
          <div className="bg-white shadow-lg p-6 flex flex-col gap-4 hover:shadow-2xl transition-all">
            <img
              src={Empowerment}
              alt="United in Empowerment"
              className=" w-full h-80 md:h-96 object-cover mb-4"
            />
            <h3 className="text-xl font-bold mb-2 flex items-center justify-between">
              United in Empowerment
            </h3>
            <p className="text-gray-600">
              As your next ECAN President, I believe true strength comes when
              every consultancy—large or small, urban or remote—thrives
              together. With our unique experience, expertise, and passion, we
              empower each member to deliver ethical, world-class guidance and
              open brighter global pathways for every Nepali student.
            </p>
          </div>
        </div>
        {/* Group Photo */}
        <div className="w-full flex justify-center">
          <img
            src={Group}
            alt="Group Social Commitment"
            className="rounded-2xl shadow-xl w-full h-80 md:h-96 object-cover"
          />
        </div>
      </div>
    </section>
  );
}

export default Commitments;
